import { PortalCustomizationInfo } from 'types/Customization';

export const portalCustomizationContentAdapter = (contents: PortalCustomizationInfo['contents']) => {
  return contents.reduce((prev, current) => ({ ...prev, [current.key]: current.value }), {});
};
